import {
  useIsMobile,
  WSElement,
  WSIcon,
  WSText
} from "@wingspanhq/fe-component-library";
import { ReactNode } from "react";
import styles from "./index.module.scss";

type Props = {
  fromLabel: string;
  fromContent: ReactNode;

  toLabel: string;
  toContent: ReactNode;
};

export const FromTo: React.FC<Props> = props => {
  const isMobile = useIsMobile();

  return (
    <WSElement className={styles.wrapper}>
      <WSElement className={styles.from}>
        <WSText.ParagraphSm mb="XS" color="gray500">
          {props.fromLabel}
        </WSText.ParagraphSm>

        <WSElement className={styles.content}>{props.fromContent}</WSElement>
      </WSElement>

      <WSIcon block name={isMobile ? "arrow-down" : "arrow-right"} />

      <WSElement className={styles.to}>
        <WSText.ParagraphSm mb="XS" color="gray500">
          {props.toLabel}
        </WSText.ParagraphSm>
        <WSElement className={styles.content}>{props.toContent}</WSElement>
      </WSElement>
    </WSElement>
  );
};
